import { ColumnsType } from '@agro-club/agroclub-shared'
import { REACT_APP_CURRENCY_SYMBOL } from 'env'
import useFormatDate from 'hooks/useFormatDate'
import { ListRequestParams } from 'modules/domain/types'
import formatNumber from 'modules/utils/numbers/formatNumber'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { AgentCell } from './AgentCell'
import { CarrierCell } from './CarrierCell'
import { DriverCell } from './DriverCell'
import { OnApprovalTripCell } from './OnApprovalTripCell'
import { TripStatusTag } from '../../TripStatusTag'

export const useOnApprovalColumns = (
  listRequestParams: ListRequestParams,
  setListRequestParams: (params: ListRequestParams) => void,
): ColumnsType<any> => {
  const { t } = useTranslation('logisticsKR')
  const formatDate = useFormatDate()
  const currency = REACT_APP_CURRENCY_SYMBOL

  return useMemo(
    () => [
      {
        title: t('details.tableHeaders.load_date'),
        width: 94,
        dataIndex: 'load_date',
        render: (load_date) => formatDate(load_date),
      },
      {
        title: t('details.tableHeaders.added_by'),
        width: 132,
        dataIndex: 'logistician',
        render: (logistician) => (logistician ? <div>{logistician.short_name}</div> : null),
      },
      {
        title: t('details.tableHeaders.contractType/Agent'),
        width: 130,
        dataIndex: 'deal_type',
        render: (deal_type, data) => (
          <div>
            <div>{t(`details.deal_types.${deal_type}`)}</div>
            <div>{data.agent ? <AgentCell name={data.agent?.name} commission={data?.agent_commission} /> : null}</div>
          </div>
        ),
      },
      {
        title: t('common:status'),
        width: 120,
        dataIndex: 'status',
        render: (status) => <TripStatusTag status={status} />,
      },
      {
        title: t('details.tableHeaders.company'),
        width: 170,
        dataIndex: 'carrier',
        render: (_, trip) => <CarrierCell trip={trip} />,
      },
      {
        title: t('details.tableHeaders.driver'),
        width: 200,
        dataIndex: 'driver',
        render: (driver, data) => <DriverCell driver={driver} trip={data} />,
      },
      {
        title: t('details.tableHeaders.price_logistics', { currency }),
        width: 95,
        align: 'right',
        dataIndex: 'price_logistics',
        render: (price_logistics) => formatNumber(price_logistics, true),
      },
      {
        title: '',
        width: 48,
        align: 'center',
        dataIndex: 'actions',
        render: (_, data) => (
          <OnApprovalTripCell
            listRequestParams={listRequestParams}
            setListRequestParams={setListRequestParams}
            tripId={data.id}
          />
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, currency, formatDate, listRequestParams],
  )
}
